angular.module("ShareWithApp").factory("ShareWithConstantsFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/profiles/sharewithconsts/:user/');
}]);
